module.exports = __webpack_public_path__ + "img/platforms.cf925b57.png";